import { Table } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'

import { PaginationMeta } from '../../models/pagination'

import { renderFormatMessage } from '../../helpers/intl'
import { SwtchError } from '../../models/error'
import { GetChargerFirmwareHistory } from '../../services/data-provider/charger'
import { FirmwareHistoryRow } from '../../models/http'
import { Charger } from '../../models/charger'

interface props {
  charger: Charger
}

export const ChargerTabFirmwareVersion: React.FC<props> = ({ charger }) => {
  const [firmwareHistory, setFirmwareHistory] = useState<FirmwareHistoryRow[]>([])
  const [pagination, setPagination] = useState<PaginationMeta>({
    currentPage: 1,
    perPage: 10,
    totalEntries: 0,
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<SwtchError>()

  const load = () => {
    if (!charger?.id) return

    setLoading(true)
    setError(undefined)

    GetChargerFirmwareHistory(currentPage, charger)
      .then((resp) => {
        setFirmwareHistory(resp.data)
        setPagination(resp.pagination)
      })
      .catch((err: SwtchError) => setError(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, charger?.id])

  const onPaginationChange = (page: number, pageSize?: number) => {
    setCurrentPage(page)
  }

  const columns = [
    {
      title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.count', 'Count'),
      key: 'count',
      dataIndex: 'count',
      render: (_: any, __: FirmwareHistoryRow, index: number) => {
        const base = (pagination.currentPage - 1) * pagination.perPage
        return pagination.totalEntries - (base + index)
      },
    },
    {
      title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.timestamp', 'Timestamp'),
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: (createdAt: string) => moment(createdAt).local().format('YYYY-MM-DD - HH:mm:ss z'),
    },
    {
      title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.serialNumber', 'Charger Serial Number'),
      key: 'serialNumber',
      dataIndex: 'serialNumber',
      render: (serialNumber: string) => serialNumber,
    },
    {
      title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.firmwareVersion', 'Firmware Version'),
      key: 'firmwareVersion',
      dataIndex: 'firmwareVersion',
      render: (firmwareVersion: string) => firmwareVersion,
    },
  ]

  return (
    <>
      {/* <AlertError error={error} /> */}
      <Table
        size="small"
        columns={columns}
        dataSource={firmwareHistory}
        loading={loading}
        pagination={{
          position: ['bottomCenter'],
          total: pagination?.totalEntries,
          current: pagination?.currentPage ?? currentPage,
          pageSize: pagination?.perPage ?? 10,
          showSizeChanger: false,
          onChange: onPaginationChange,
        }}
        rowKey={(row: FirmwareHistoryRow): string =>
          `${row.createdAt}-${row.serialNumber}-${row.firmwareVersion}`
        }
      />
    </>
  )
}
